import { AnchorButton } from '@blueprintjs/core';
import { mdiHelpCircle } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectApp } from 'uf/app/slice';
import { logEvent } from 'uf/logging';
import { IconSizeNew } from 'uf/ui/base/icon';
import { useOrgHelpURL } from 'uf/ui/organization/hooks';
import { sources } from 'uf/ui/user/logging';
import { FEATURE_DOCUMENTATION_OPENED } from 'uf/user/logging';

const HelpLink = () => {
  const { activeProjectId } = useSelector(selectApp);
  const { data: helpURL, isLoading } = useOrgHelpURL();
  const handleClick = () => {
    logEvent(FEATURE_DOCUMENTATION_OPENED, {
      projectId: activeProjectId,
      source: sources.HELP_LINK,
    });
  };
  return (
    <AnchorButton
      minimal
      target="_blank"
      rel="noreferrer noopener"
      className="tw-p-0 tw-text-blueGray-400 hover:tw-text-white tw-flex tw-flex-grow tw-w-16"
      onClick={handleClick}
      href={helpURL}
      icon={<Icon path={mdiHelpCircle} size={IconSizeNew.SMALL} />}
      loading={isLoading}
    />
  );
};

export default HelpLink;
